<script>
import {BBadge} from 'bootstrap-vue'
import MoreElements from "@/views/product/components/product-card/composition/substance/details/view/MoreElements.vue";
export default {
    components: {MoreElements, BBadge},
    props: {
        substance: {
            required: true,
            type: Object,
        },
        details: {
            required: true,
            type: Array,
        },
        mode: {
            required: true
        }
    },
    methods: {
        makeTitleList(kind) {
            const elements = [];
            this.details
                .filter(d => d.hasOwnProperty(kind) && d[kind])
                .forEach(d => {
                    if (!elements.includes(d[kind].title)) {
                        elements.push(d[kind].title);
                    }
                });

            if (elements.length === 0) {
                elements.push('-')
            }

            return elements;
        }
    },
    computed: {
        concentrationRanges() {
            return this.makeTitleList('concentrationRange');
        },
        maxConcentration() {
            return this.details
                .filter(d => d.maxConcentration)
                .map(d => d.maxConcentration)
                .join('; ');
        },
        exemption() {
            return this.details
                .filter(d => d.exemption)
                .map(d => d.exemption)
                .join('; ');
        }
    }
}
</script>

<template>
    <div>
        <h5>{{ $t('Component(CompositionSubstance):max-concentration') }}</h5>
        <div class="mb-1">{{ maxConcentration ? maxConcentration : '-' }}</div>

        <h5>{{ $t('Component(CompositionSubstance):rohs-exemption') }}</h5>
        <div class="mb-1">{{ exemption ? exemption : '-' }}</div>
    </div>
</template>

